enum MaterialEcoIndicatorId {
    Good = 'good',
    Regular = 'regular',
    Bad = 'bad',
    VeryBad = 'veryBad',
}

export default MaterialEcoIndicatorId;
